import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges, OnDestroy, Output, EventEmitter, AfterViewInit
} from '@angular/core';
import * as c3 from 'c3';
import { GraphUtilsService } from '../../services/graph-utils.service';
import { DataService } from '../../services/data.service';
import { UtilsService } from '../../services/utils.service';

@Component({
    selector: 'app-c3-trend-series',
    templateUrl: './c3-trend-series.component.html',
    styleUrls: ['./c3-trend-series.component.scss'],
    standalone: false
})
export class C3TrendSeriesComponent implements OnChanges, AfterViewInit, OnDestroy {

  @Input() data: any;
  @Input() paramNameList: any;
  @Input() param1: any;
  @Input() param2: any;
  @Input() param3: any;
  @Input() param4: any;
  @Input() param5: any;
  @Input() param6: any;
  @Input() inclindXaxis = 0;

  trendChart: any = null;
  subscriptions: any;
  data1: any[] = [];
  data2: any[] = [];
  data3: any[] = [];
  data4: any[] = [];
  data5: any[] = [];
  data6: any[] = [];
  constructor(
    private graphUtil: GraphUtilsService,
    private elRef: ElementRef,
    private dataServ: DataService, private utilsService: UtilsService
  ) {

    this.subscriptions = dataServ.events.subscribe(this.replotGraphEventSubscription);
  }

  replotGraphEventSubscription = (res: any) => {
    if (res.name === 'replotGraph') {
      let timeoutval = 0;
      if (res.args && res.args[0] === 'menuToggle') {
        timeoutval = 101;
      }
      setTimeout(() => {
        this.checkAndReplotTrendGraph();
      }, timeoutval);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.checkAndReplotTrendGraph();
  }

  ngAfterViewInit(): void {
    this.checkAndReplotTrendGraph();
  }

  checkAndReplotTrendGraph() {
    if (this.data && this.data.length) {
      this.data1 = this.param1 ? this.param1 : [];
      this.data2 = this.param2 ? this.param2 : [];
      this.data3 = this.param3 ? this.param3 : [];
      this.data4 = this.param4 ? this.param4 : [];
      this.data5 = this.param5 ? this.param5 : [];
      this.data6 = this.param6 ? this.param6 : [];
      this.generateChart(this.data);
    }
  }

  setLegendLabel(ind) {
    if (this.paramNameList.length - 1 >= ind) {
      return this.paramNameList[ind].parametername;
    }
    return null;
  }

  generateChart = (data) => {
    const range = this.data1.map(elem => elem.value).concat(this.data2.map(elem => elem.value), this.data3.map(elem => elem.value),
      this.data4.map(elem => elem.value), this.data5.map(elem => elem.value), this.data6.map(elem => elem.value))
    this.trendChart = c3.generate({
      bindto: this.elRef.nativeElement.children[0].children[0],
      legend: {
        show: true
      },
      padding: {
        right: 25,
      },
      data: {
        xs: {
          data1: 'x1',
          data2: 'x2',
          data3: 'x3',
          data4: 'x4',
          data5: 'x5',
          data6: 'x6',
        },
        columns: [
          ['x1', ...this.data1.map(elem => elem.convertedTS)],
          ['x2', ...this.data2.map(elem => elem.convertedTS)],
          ['x3', ...this.data3.map(elem => elem.convertedTS)],
          ['x4', ...this.data4.map(elem => elem.convertedTS)],
          ['x5', ...this.data5.map(elem => elem.convertedTS)],
          ['x6', ...this.data6.map(elem => elem.convertedTS)],
          ['data1', ...this.data1.map(elem => elem.value)],
          ['data2', ...this.data2.map(elem => elem.value)],
          ['data3', ...this.data3.map(elem => elem.value)],
          ['data4', ...this.data4.map(elem => elem.value)],
          ['data5', ...this.data5.map(elem => elem.value)],
          ['data6', ...this.data6.map(elem => elem.value)]
        ],
        type: 'line',
        names: {
          data1: this.setLegendLabel(0),
          data2: this.setLegendLabel(1),
          data3: this.setLegendLabel(2),
          data4: this.setLegendLabel(3),
          data5: this.setLegendLabel(4),
          data6: this.setLegendLabel(5)
        }
      },
      transition: {
        duration: 0
      },
      point: {
        r: 3
      },
      axis: {
        x: {
          type: 'timeseries',
          tick: {
            count: this.data && this.data.length ? (this.data.length < 10 ? 10 : this.data.length) : 10,
            // format: '%_d %b %y %H:%M',
            multiline: true,
            rotate: this.inclindXaxis,
            format: (x: any) => {
              if (!x || x.toString() === 'Invalid Date' || isNaN(x)) {
                return '';
              }
              const str = x ? this.utilsService.formatDateDDMonYYHHMM(x) : '';
              return str;
            }
          },
        },
        y: {
          max: Math.max(...range)
        }
      },
      zoom: {
        type: 'scroll',
        enabled: true
      },
      grid: {
        lines: {
          front: false
        }
      },
      color: {
        pattern: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d1d407', '#da7698', '#798998']
      },
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
